import clsx from 'clsx'
import * as React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher, AdminAccountSwitcher} from '../../../partials'
import AdminIssuesWidget from '../../../partials/layout/header-menus/AdminIssuesWidget'
import {AdminSubscriptionDaysWidget} from '../../../partials/layout/header-menus/AdminSubscriptionDaysWidget'
import NotificationBell from '../../../../app/modules/admin/NotificationBell'
// import {HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'
import {useNavigate, useLocation} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'

const itemClass = 'ms-1 ms-lg-3'
const btnClass =  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'


const Navbar = () => {
  const {config} = useLayout()
  const [value, setValue] = React.useState('addnew')
  let navigate = useNavigate();
  const {currentUser, logout, getBot, _setCurrentBot} = useAuth()
  const location = useLocation();

  // if (!getBot()._id && location.pathname !== '/new-bot') {
  //   console.log(1111111);
  //   // return navigate('/new-bot')
  // }

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    _setCurrentBot(event.target.value)
    setValue(event.target.value);

    let value = event.target.value
    if (value === 'addnew') {
      navigate('/new-bot')
    } else {
      navigate('/campaigns')
    }
  }
  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div> */}

      {/*<div className={clsx('app-navbar-item', itemClass)}>
        <select
          name='add boat'
          className='form-select form-select-sm form-select-solid'
          onChange={handleChange}
          value={window.location.pathname === '/new-bot' ? 'addnew' : (getBot() ? getBot()._id : null)}
        >
          {currentUser?.bots && currentUser?.bots.map((bot) => <option value={bot._id}>{bot.name}</option>)}
          <option value='addnew'>+ Add New Bot</option>
        </select>
      </div>*/}

      {false && <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass + ' position-relative'}
        >
          <span className='hhhh bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' style={{



          }}>24</span>
            {/*<span className="badge badge-secondary">24</span>*/}
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="40"
  height="40"
  fill="currentColor"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9z" />
  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
</svg>
        </div>
        <HeaderNotificationsMenu />
      </div>}

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTSVG path='/media/icons/duotune/communication/com012.svg' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div> */}

      {/* Trial period indicator */}
      {currentUser?.trial_period_end && (() => {
        const endDate = new Date(currentUser.trial_period_end)
        const now = new Date()
        const diffDays = Math.ceil((endDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))
        const isExpired = diffDays < 0
        const formattedDate = endDate.toLocaleDateString('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric' })
        return (
          <div className={clsx('app-navbar-item d-none d-lg-flex', itemClass)}>
            <span
              className={`badge ${isExpired ? 'badge-light-danger' : diffDays <= 7 ? 'badge-light-warning' : 'badge-light-success'} fw-bold fs-7 px-3 py-2`}
              title={`מנוי פעיל עד: ${formattedDate}`}
            >
              {isExpired
                ? `המנוי הסתיים (${formattedDate})`
                : diffDays === 0
                  ? `המנוי מסתיים היום`
                  : diffDays === 1
                    ? `המנוי מסתיים מחר`
                    : `פעיל: ${diffDays} ימים (${formattedDate})`
              }
            </span>
          </div>
        )
      })()}

      {/* Copy account info button */}
      {currentUser && (() => {
        const accountId = (currentUser as any)._id || currentUser.id
        const username = currentUser.username || currentUser.email
        if (!accountId) return null
        const copyText = `${username} | ${accountId}`
        return (
          <div className={clsx('app-navbar-item d-none d-lg-flex', itemClass)}>
            <span
              className='badge badge-light-dark fw-bold fs-7 px-3 py-2'
              style={{ cursor: 'pointer', userSelect: 'none' }}
              title={copyText}
              onClick={() => {
                navigator.clipboard.writeText(copyText)
                const el = document.getElementById('copy-account-info-badge')
                if (el) {
                  el.textContent = 'Copied!'
                  setTimeout(() => { el.textContent = username || accountId }, 1200)
                }
              }}
            >
              <span id='copy-account-info-badge'>{username || accountId}</span>
            </span>
          </div>
        )
      })()}

      {/* Account start date */}
      {currentUser?.created_at && (() => {
        const createdDate = new Date(currentUser.created_at)
        const formattedDate = createdDate.toLocaleDateString('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric' })
        const now = new Date()
        const diffDays = Math.floor((now.getTime() - createdDate.getTime()) / (1000 * 60 * 60 * 24))
        const seniority = diffDays < 30 ? `${diffDays} ימים` : diffDays < 365 ? `${Math.floor(diffDays / 30)} חודשים` : `${(diffDays / 365).toFixed(1)} שנים`
        return (
          <div className={clsx('app-navbar-item d-none d-lg-flex', itemClass)}>
            <span className='badge badge-light-info fw-bold fs-7 px-3 py-2' title={`תאריך הצטרפות: ${formattedDate}`}>
              {formattedDate} ({seniority})
            </span>
          </div>
        )
      })()}

      {/* Admin Account Switcher - only shows if admin is logged in (desktop only) */}
      <div className='d-none d-lg-flex align-items-center'>
        {/* Its own header button, independent of the account switcher: add/remove
            subscription days for the customer currently open. Renders only for a
            valid admin token. */}
        <AdminSubscriptionDaysWidget />
        <AdminAccountSwitcher />
        <NotificationBell />
        <AdminIssuesWidget />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        {<div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <div
            style={{
              width: '35px',
              height: '35px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #1877f2 0%, #0d65d9 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontWeight: '600',
              fontSize: '14px',
              textTransform: 'uppercase'
            }}
          >
            {currentUser?.first_name?.charAt(0) || currentUser?.email?.charAt(0) || '?'}
          </div>
        </div>}
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export {Navbar}
